import React, {useCallback, useEffect, useState} from "react";
import axios from "axios";
import {API_BASE_URL} from "../../config";
import 'quill/dist/quill.snow.css';
import 'react-quill/dist/quill.snow.css';
import QuillEditor from "../components/QuillEditor";
import {useNavigate} from 'react-router-dom'

const SupportTicket = () => {
    const [department, setDepartment] = useState("");
    const [departments, setDepartments] = useState([]);
    const [description, setDescription] = useState("");
    const [ticketType, setTicketType] = useState("");
    const [ticketTypes, setTicketTypes] = useState([]);
    const [customerProducts, setCustomerProducts] = useState([]);
    const [customerProduct, setCustomerProduct] = useState("");
    const [loading, setLoading] = useState(false); // Loading state
    const navigate = useNavigate(); // Create navigate function
    const [message, setMessage] = useState("")

    const [attachments, setAttachments] = useState([]);

    const [bexioId] = useState(() => {
        const params = new URLSearchParams(window.location.search);
        return params.get('bexio_id');
    });

    const fileHandler = useCallback(() => {
        const input = document.createElement("input");
        input.setAttribute("type", "file");
        // Types de documents autorisés, comme c'est côté client, on évite les .XML, .SVG, les fichiers avec des macros etc pour éviter les failles de sécurité XSS
        input.setAttribute(
            "accept",
            [
                // documents
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-powerpoint",
                "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                "text/plain",
                "application/zip",
                "application/x-zip-compressed",
                // images
                "image/jpeg",
                "image/jpg",
                "image/png",
                "image/gif",
                "image/webp"
            ].join(",")
        );
        input.multiple = true;

        input.click();

        input.onchange = async () => {
            const files = Array.from(input.files || []);
            if (!files.length) return;

            for (const file of files) {
                // Petit check de taille max côté client de 20Mo, un autre check est de toute façon fait côté serveur
                const MAX_MB = 20;
                if (file.size > MAX_MB * 1024 * 1024) {
                    console.warn(`Le fichier ${file.name} est trop volumineux. Essayez de le compresser ou de nous envoyer un lien SwissTransfer par exemple.`);
                    continue;
                }

                try {
                    const formData = new FormData();
                    formData.append("file", file);

                    const {data} = await axios.post(`${API_BASE_URL}/upload_file`, formData, {headers: {"Content-Type": "multipart/form-data"}});

                    // data: { url, name, size, type }
                    setAttachments((prev) => [...prev, data]);
                } catch (err) {
                    console.error("File upload failed:", err);
                }
            }
        };
    }, []);

    useEffect(() => {
        axios.post(`${API_BASE_URL}/get_all_departments`)
            .then(res => {
                setDepartments(res.data);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });
    }, []);

    const saveTicket = () => {
        setLoading(true); // Start loading
        //const user_id = localStorage.user_id;
        const datas = {
            department,
            //user_id,
            ticketType,
            description,
            bexioId,
            customerProduct,
            attachments
        };

        axios
            .post(`${API_BASE_URL}/save_ticket_from_console`, datas)
            .then((res) => {
                if (res.status === 201) {
                    // Navigate to the success component
                    navigate("/support-ticket-success");
                }
            })
            .catch((error) => {
                console.error("Error creating ticket:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        if (department) {
            axios.post(`${API_BASE_URL}/get_tickets_types_for_console`, {department})
                .then((res) => {
                    setTicketTypes(res.data);
                });

            axios.post(`${API_BASE_URL}/get_customer_products`, {id: bexioId})
                .then(res => {
                    setCustomerProducts(res.data);
                })
                .catch(error => {
                    console.error("Error fetching data:", error);
                });
        }
    }, [department]);

    const handleCreateTicket = (e) => {
        e.preventDefault();
        if (!loading && department && description && ticketType) {
            saveTicket();
        } else {
            setMessage("Merci de remplir tous les champs")
        }
    };

    return (
        <div>
            <div className="register-container">
                <form className="">
                    <div style={{padding: '20px 10px', borderRadius: 10, backgroundColor: "transparent"}}>

                        <h2 className="title mt-0 mb-40 text-left">Contacter notre service client</h2>

                        {/* Department Selection */}
                        <div>
                            <div className="display-flex justify-content-space-between flex-direction-column">

                                {/* Département concerné */}
                                <label>Département concerné*</label>
                                <div className="custom-select-wrapper">
                                    <select
                                        className="custom-select"
                                        value={department}
                                        onChange={(e) => setDepartment(e.target.value)}
                                        required
                                    >
                                        <option value="" disabled>Choisir un département</option>
                                        {departments
                                            .filter(d => d.name !== "Non déterminé") // 👈 Hide unwanted item
                                            .map((departementOption) => (
                                                <option key={departementOption.id} value={departementOption.id}>
                                                    {departementOption.name}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                {/* Type de ticket */}
                                <label>Type de ticket*</label>
                                <div className="custom-select-wrapper">
                                    <select
                                        className="custom-select"
                                        value={ticketType}
                                        onChange={(e) => setTicketType(e.target.value)}
                                        required
                                    >
                                        <option value="" disabled>Type de ticket</option>
                                        {ticketTypes.map((type) => (
                                            <option key={type.id} value={type.id}>{type.name}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Produit concerné */}
                                {(customerProducts.length > 0 && ticketType) && (
                                    <>
                                        <label>Produit concerné (optionnel)</label>
                                        <div className="custom-select-wrapper">
                                            <select
                                                className="custom-select"
                                                value={customerProduct}
                                                onChange={(e) => setCustomerProduct(e.target.value)}
                                            >
                                                <option value="" disabled>Mon produit</option>
                                                {customerProducts.map((type) => (
                                                    <option key={type.intern_name} value={type.intern_name}>
                                                        {type.intern_name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                        {ticketType && (<>
                                <div
                                    className="input-container mb-0 ticket-description-container display-flex flex-direction-column">
                                    <div className="w-100">
                                        <label>Votre message*</label>
                                        <div style={{minHeight: 200, marginTop: 20}} className={"console-ticket"}>
                                            <QuillEditor
                                                value={description}
                                                onChange={setDescription}
                                                required
                                            />
                                        </div>

                                    </div>
                                </div>

                                <div style={{marginBottom: 20, display: "flex", gap: 8}}>
                                    <button className={"mt-20"}
                                        type="button"
                                        onClick={fileHandler}
                                        style={{
                                            padding: "8px 16px",
                                            borderRadius: 6,
                                            border: "none",
                                            background: "#0d6efd",
                                            color: "#fff",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <i className="fa-regular fa-paperclip" style={{marginRight: 6}}/> Joindre des
                                        fichiers
                                    </button>

                                    {console.log(attachments)}

                                    {/* Tiny attachments preview */}
                                    {!!attachments.length && (<div style={{fontSize: 13}}>
                                        {attachments.map((a, idx) => (<span key={idx} style={{marginRight: 10}}>
                                  <a href={a.url} target="_blank" rel="noreferrer">{a.name}</a>
                                  <button
                                      type="button"
                                      onClick={() => setAttachments((prev) => prev.filter((_, i) => i !== idx))}
                                      style={{
                                          marginLeft: 6, border: "none", background: "transparent", cursor: "pointer",
                                      }}
                                      title="Remove"
                                  >
                                    ×
                                  </button>
                                </span>))}
                                    </div>)}
                                </div>
                            </>
                        )}

                        {/* Buttons */}
                        <div className="display-flex justify-content-end gap-10 btn-container mt-15">
                            <button
                                type="button"
                                onClick={handleCreateTicket}
                                className="btn-submit-account send"
                            >
                                {loading ? (
                                    <>
                                        <i className="fas fa-spinner fa-spin"></i> Envoi en cours...
                                    </>
                                ) : (
                                    "Envoyer ma demande"
                                )}
                            </button>

                        </div>
                        {
                            message &&
                            <div style={{marginTop: 20}}><span style={{marginTop: 20}}>{message}.</span></div>
                        }
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SupportTicket;
